// extracted by mini-css-extract-plugin
export default {"expandButton":"expand_button_expandButton__4QG7Q","arrowIcon":"expand_button_arrowIcon__lkG9d","arrowIconInverted":"expand_button_arrowIconInverted__Y8mlF"};